import type { IdentityFormData } from './identityHelpers'

export type LoggedInIdentityProfile = {
  email?: string | null
  name?: string | null
  meta?: Record<string, string>
}

export function identityDataForStripe(
  values: IdentityFormData,
  loggedInProfile?: LoggedInIdentityProfile | null,
): IdentityFormData {
  if (loggedInProfile) {
    const meta = { ...(loggedInProfile.meta ?? {}) }

    // TIC-1822 Do not send Zip code when payment is for logged in member
    delete meta.zip_code

    return {
      ...meta,
      name: loggedInProfile.name ?? undefined,
      email: loggedInProfile.email ?? undefined,
    } as IdentityFormData
  }

  const first = values.first_name
  const last = values.last_name
  return {
    ...values,
    name: first && last ? `${first} ${last}` : undefined,
  } as IdentityFormData
}
